import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';

export default class ReportResolvedNotification extends Notification {
  icon() {
    return this.attrs.notification.content().action === 'delete' ? 'fas fa-trash-alt' : 'fas fa-check-circle';
  }

  href() {
    const data = this.attrs.notification.content();

    return data.action === 'delete' ? '#' : app.route('discussion', { id: data.discussionId });
  }

  content() {
    const action = this.attrs.notification.content().action;

    return app.translator.trans(
      action === 'delete'
        ? 'yingtao-forum-homepage.forum.notifications.report_deleted'
        : 'yingtao-forum-homepage.forum.notifications.report_restored'
    );
  }

  excerpt() {
    return null;
  }
}
